export class GetDonateWalletTransactions {
  static readonly type = "[Transaction] Get Donate Wallet Transactions";
  constructor(
    public page: number,
    public pageSize: number
  ) {}
}

export class GetStoreWalletTransactions {
  static readonly type = "[Transaction] Get Store Wallet Transactions";
  constructor(
    public page: number,
    public pageSize: number
  ) {}
}

